import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import AnimatedPage from './AnimatedPage';
import { calcInteractions } from '../helpers/functions';

export default function ChildPage(props) {
  const { 
    BgImage, 
    VideoTransitionIn, 
    VideoBgLoop, 
    VideoTransitionOut,
  } = props;
  const navigate = useNavigate();
  const [interactionsWidth, setInteractionsWidth] = useState('0px');
  const [interactionsHeight, setInteractionsHeight] = useState('0px');
  
  useEffect(() => {
    let isMounted = true;
    const sixteenNineAspect = 16 / 9;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const widthIfConstarainedByHeight = viewportHeight * sixteenNineAspect;
    const heightIfConstarainedByWidth = viewportWidth / sixteenNineAspect;
    const videoTransitionIn = document.querySelector('.video-transition-in');
    const videoBgLoop = document.querySelector('.video-bg-loop');
    const videoTransitionOut = document.querySelector('.video-transition-out');
    const back = document.querySelector('.back');
    
    // calculate interactions size on load
    if (widthIfConstarainedByHeight <= viewportWidth) {
      setInteractionsWidth(widthIfConstarainedByHeight + "px");
      setInteractionsHeight(viewportHeight + "px");
    } else {
      setInteractionsWidth(viewportWidth + "px");
      setInteractionsHeight(heightIfConstarainedByWidth + "px");
    }

    // functions    
    const playBgLoop = () => {
      videoBgLoop.classList.remove('d-none');
      videoBgLoop.play();
    }

    const navigateBack = () => {
      navigate("/");
    }

    const handleBackClick = () => {
      videoTransitionOut.classList.remove('d-none');
      videoTransitionOut.play();
    }

    // listeners
    window.addEventListener('resize', calcInteractions);
    videoTransitionIn.addEventListener('ended', playBgLoop);
    videoTransitionOut.addEventListener('ended', navigateBack);
    back.addEventListener('click', handleBackClick);

    // transition in
    const transitionIn = setTimeout(() => {
      if (isMounted) {
        videoTransitionIn.play();
      }
    }, 500);

    // Unmount -> cleanup
    return () => {
      isMounted = false;
      clearTimeout(transitionIn);
    };
  }, [navigate]);
  
  return (
    <AnimatedPage>
      <main className="d-flex flex-grow-1 flex-column justify-content-center align-items-center bg-black overflow-hidden">
        <div className="ratio ratio-16x9 mh-100vh">
          <img src={BgImage} style={{objectFit: 'contain'}} alt="Home img" />
          <video 
            src={VideoTransitionIn} 
            type="video/mp4" 
            className="video-transition-in w-100" 
            muted
          />
          <video 
            src={VideoBgLoop} 
            type="video/mp4" 
            className="video-bg-loop d-none w-100" 
            loop
            muted
          />
          <div className="interactions overflow-hidden" style={{width: interactionsWidth, height: interactionsHeight}}>
            <button className="back">
              <div className="position-absolute nav-home" style={{width: 15 + '%', height: 18 + '%', bottom: 0 + '%', left: 0 + '%'}}></div>
            </button>

            {props.children}
          </div>
          <video 
            src={VideoTransitionOut} 
            type="video/mp4" 
            className="video-transition-out d-none w-100" 
            muted
          />
        </div>
      </main>
    </AnimatedPage>
  )
}
